module.exports = __webpack_public_path__ + "img/svg/step8.e20b7213e52d4327a42bf20ccad2852a.svg";